<template>
  <div
    class="!flex items-center justify-center cursor-default overflow-y-auto"
    dir="ltr"
  >
    <div class="container w-full my-auto py-20 max-w-screen-md space-y-4">
      <TitleCard v-if="title" :title />
      <NamiButton v-if="title" button-type="primary" block :href="linkTo(title)"
        >{{ translate("components.reader.endCard.returnToTitle") }}
      </NamiButton>
      <div class="tile space-y-2">
        <div class="font-bold">Share Your Love</div>
        <div>
          {{ translate("components.reader.endCard.finishedChapterMessage") }}
        </div>
        <Skeleton v-if="pending" />
        <Reader2InterludeShareBlock
          v-else-if="chapterData && title"
          :title="title"
          :chapter="chapterData"
        />
      </div>
      <div class="space-y-2 tile">
        <div class="font-bold">
          {{ translate("components.reader.endCard.topComments") }}
        </div>
        <FeedCommentPreview feed-type="chapter" :feed-id="page.chapterId" />
        <div class="p-2">
          <NamiButton
            button-type="secondary"
            @buttonClick="() => $emit('openComments')"
            block
            text
            >{{ translate("components.reader.endCard.allComments") }}
          </NamiButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { isTitle, type TitleEntity } from "~/src/api";
import type { InterludePageGroup } from "~/src/reader/managers/pageGroup";
import { getReaderChapter } from "~/src/reader/managers/chapter";
import { useQuery, useQueryClient } from "@tanstack/vue-query";
import { useTitleGet } from "~/utils/tanstack/title";
import { getSingleEntityFromCache } from "~/utils/tanstack";
import { getReaderTitle } from "~/src/reader/managers/title";

interface Props {
  page: InterludePageGroup;
}

interface Emits {
  (e: "openComments"): void;
}

const props = defineProps<Props>();
defineEmits<Emits>();

const nuxtApp = useNuxtApp();
const { locale, t: translate } = useI18n();
const queryClient = useQueryClient();

const { data: chapterData, isPending: pending } = getReaderChapter(
  () => queryClient,
  props.page.chapterId,
);
const fetchedTitleId = computed(
  () => chapterData.value?.relationships.find(isTitle)?.id,
);
const { data: title } = getReaderTitle(() => queryClient, fetchedTitleId);

const titleFollow = ref();
watch(title, (v) => {
  if (!v) return;
  titleFollow.value = useTitleFollow(v.id);
});
</script>

<style scoped lang="postcss"></style>
